export const DATE_FILTER_NOT_REFLECTED_ALL_TIME_TOTAL_DISCLAIMER = "Your all time total, not reflected by date filter"
export const DEFAULT_CARD_ERROR_MESSAGE = "We had an unexpected error, please refresh the card"
export const DEFAULT_ERROR_MESSAGE = "We had an unexpected error, please refresh the page"
export const NOT_FOUND_CARD_ERROR_MESSAGE = "Resource not found"
export const UNAUTHORIZED_CARD_ERROR_MESSAGE = "You don't have permission to view this data"
export const FATAL_ERROR_CARD_ERROR_MESSAGE = "Server encountered a fatal error"
export const BAD_REQUEST_CARD_ERROR_MESSAGE = "There was a problem with the request"

export const errorMessages: Record<number, string>  = {
  404: NOT_FOUND_CARD_ERROR_MESSAGE,
  401: UNAUTHORIZED_CARD_ERROR_MESSAGE,
  500: FATAL_ERROR_CARD_ERROR_MESSAGE,
  400: BAD_REQUEST_CARD_ERROR_MESSAGE
}
export const ABOVE = 'above'
export const BELOW = 'below'
export const DATE_FILTER_ONLY_FULL_MONTH_DISCLAIMER = "Includes only full month"
export const POTENTIAL_CLIENTS = 'Profile views'
export const INFLUENCED = 'Influenced'
export const RECOMMENDERS = 'Recommenders'
export const TOP_RATED_ADVISERS = 'Top rated advisers'
export const SEE_MORE = "See More"
export const VERIFIED_HOMEPAGE_SECTION_CTA_LABEL = "Explore by adviser"
export const CONSUMER_DUTY_SCORE = 'Potential risk'
export const RECOMMENDATIONS_PER_CLIENT = 'average referrals per client'
export const GROWTH_OPPORTUNITIES = 'Growth opportunities'
export const UPGRADE_TO_VERIFIED = "Upgrade to Verified"
export const UPGRADE_TO_ELEVATION = "Upgrade to Elevation"
export const NOT_ENOUGH_DATA = "You don't have enough reviews to view this data"
export const DATA_DISTRIBUTION_CARD_LOADING = "Hang tight — we're loading the latest insights to help you and your firm elevate client experience and performance."
export const POTENTIAL_RISK = 'Potential risk'
export const POTENTIAL_RISK_MAIN_CARD_CONTENT_FIRST_SECTION = 'Potential risk is calculated by dividing the number of reviews with at least one potential risk marker by the number of reviews'
export const POTENTIAL_RISK_MAIN_CARD_CONTENT_SECOND_SECTION = 'The answers highlighted in orange are the answers that we consider to be a marker of potential risk'
export const RISK_DESCRIPTION = 'show markers of risk'
export const PROSPECT_CONVERSION = 'of prospects intend to become a client'
export const DEFAULT_CARD_LIST_ERROR_MESSAGE = 'Sorry, there was an unexpected error while loading your insights. Please try again'
export const QUESTION_RANK_ERROR_MESSAGE = 'Sorry, there was an unexpected error while loading rank. Please try again'
export const LOADING_SERVICE_TYPE = 'Loading service type'
export const HOW_TO_USE_THIS_DASHBOARD = 'How to use this dashboard'
export const PROSPECT_CONVERSION_MAIN_CARD_CONTENT_FIRST_SECTION = 'Prospect conversion is calculated by looking at the proportion of respondents answering “Yes” to the question “Are you going to use the advisers’ services in the future?”'
export const PROSPECT_CONVERSION_MAIN_CARD_CONTENT_SECOND_SECTION = 'The answers highlighted in green strongly correlate with increased likelihood that the prospect will become a client'
export const RECOMMENDATIONS_PER_CLIENT_MAIN_CARD_CONTENT_FIRST_SECTION = 'Recommendations per client is calculated by dividing the number of reviews by the sum of answers to the question How many times have you recommended the adviser in the last 12 months?'
export const RECOMMENDATIONS_PER_CLIENT_MAIN_CARD_CONTENT_SECOND_SECTION = 'The questions below highlight key drivers of client advocacy. The answers highlighted in green are strongly correlated with increased likelihood that the client will refer their adviser to someone else.'
export const EXPLORE_FURTHER= "Choose how you'd like to explore this question further"
export const ACTIONS_ON_ELEVATION_DATA= "Types of action you can take on Elevation data"
export const INDUSTRY_BREAKDOWN_TABLE_TITLE= "See how the industry stacks up"
export const INDUSTRY_BREAKDOWN_TABLE_EXPLAINER = 'Industry rankings are based on reviews\nfrom the past 365 days and only include firms\nwith more than 30 reviews to ensure\nfair and statistically reliable comparisons.'
export const TOOLTIP_INFLUENCED = 'Those who answered positively to whether\nthey read your reviews before contacting\nyou or becoming a client'
export const TOOLTIP_RECOMMENDERS = 'Those who answered positively to whether your reviews\non VouchedFor mean they would be more confident\nrecommending you to a friend'
export const METRIC_1_TITLE = "Prospect conversion"
export const METRIC_2_TITLE = "Recommendations per client"
export const METRIC_3_TITLE = "Potential risk"
export const EXPLORE_GOAL_FURTHER= "Choose how you'd like to explore this goal further"
export const ELEVATION_BY_ADVISER_PAGE_SUBTITLE = 'Clicking on one of the three scores for each adviser will take you to the advisers Elevation dashboard'
export const ADVISER_PERFORMANCE_PAGE_SUBTITLE = "Clicking on the adviser name will take you to the advisers Elevation dashboard"
export const VERSUS_AVERAGE = 'vs average'
export const INDUSTRY_AVERAGE = 'industry average'
export const MATCHING_INDUSTRY_AVERAGE = 'matching industry average'
export const MATCHING_INDUSTRY_AVERAGE_TOOLTIP = 'Your score is the same as the industry average'
export const VERIFIED_UPSELL_TITLE = "Build trust and credibility with public profiles and detailed analytics"
export const VERIFIED_UPSELL_REASONS = [
  {
    id: 'verified_upsell_reason_1',
    label: 'Public profile with strong Google presence',
  },
  {
    id: 'verified_upsell_reason_2',
    label: 'Marketing tools that increase conversion and referrals',
  },
  {
    id: 'verified_upsell_reason_3',
    label: "See who’s viewed your profile – and where they’ve come from"
  },
]
export const ELEVATION_UPSELL_TITLE = "Power your Consumer Duty response and grow revenue using client feedback"
export const ELEVATION_UPSELL_REASONS = [
  {
    id: 'elevation_upsell_reason_1',
    label: 'Benchmark each adviser’s service against industry averages',
  },
  {
    id: 'elevation_upsell_reason_2',
    label: 'Uncover patterns in potential issues and with specific clients',
  },
  {
    id: 'elevation_upsell_reason_3',
    label: 'Discover new opportunities with existing clients',
  },
]

export const CHOOSE_QUESTION_TEXT = "Choose a question to compare performance across advisers"
export const OVERALL_PERFORMANCE = 'Overall Performance'
export const ELEVATION_PERFORMANCE = 'Elevation Performance (2 out of 3 criteria required)'
export const CONGRATULATIONS = 'Congratulations!'
export const INVITE_REVIEWS = 'Invite reviews'

export const TRF_COMPARE_FIRMS_PAGE_SUBTITLE = 'To qualify, firms need to:'
export const NOTIFIED_VF_TEAM = "Our team has been notified and will verify this shortly"
export const NOTIFIED_VF_TEAM_ADD_ADVISERS = "Our team has been notified and will get in touch with you shortly"
export const TOP_RATED_STATUS_ELEVATION_UPSELL_BANNER_TITLE = 'Join the UK\'s Top Rated Firms'
export const TOP_RATED_STATUS_ELEVATION_UPSELL_BANNER_LINE1_PART_1 = 'Celebrate your team\'s excellence, build client trust, and gain recognition through VouchedFor\'s'
export const TOP_RATED_STATUS_ELEVATION_UPSELL_BANNER_LINE1_PART_2 = "Top Rated Firm"
export const TOP_RATED_STATUS_ELEVATION_UPSELL_BANNER_LINE1_PART_3 = 'status.'
export const TOP_RATED_STATUS_ELEVATION_UPSELL_BANNER_LINE2_PART_1 = '\u201C[Being a Top Rated Firm] builds adviser confidence, strengthens culture, and gives you direct client insight you can act on. It\'s one of the best things we\'ve done in the last few years.\u201D'
export const TOP_RATED_STATUS_ELEVATION_UPSELL_BANNER_LINE2_PART_2= '– Forrester Boyd Financial Services'
export const TOP_RATED_STATUS_ELEVATION_UPSELL_BANNER_CTA = 'Register interest today'

export const PASSWORD_VALIDATION_CRITERIA = {
  'password_characters_count': 'Your password must be at least 10 characters',
  'password_letters_and_numbers': 'Your password must contain a combination of letters and numbers',
  'password_lower_upper': 'Your password must contain a combination of lower and upper case',
}
export const PASSWORD_SUCCESSFULLY_UPDATED = "Thank you! Your password has been successfully updated. You can now log in to your account"
export const PASSWORD_SUCCESSFULLY_CHANGED= "Your password has been successfully changed"
export const SET_PASSWORD = "Set your password for your VouchedFor Firm account"
export const ALREADY_UPDATED_OR_WRONG_TOKEN = "Your password was already updated using this URL"
export const CONTACT_VF_SUPPORT = "Please contact VouchedFor support for further details"
export const NEED_HELP = "Need help"
export const CALL_US = "Call us on"
export const TERMS_TITLE = "Our terms"
export const TERMS_CONFIRM_PROMPT = "Please confirm you accept the terms of use by clicking below."
export const TERMS_READ_LINK = "Read the Terms and Conditions"
export const TERMS_ACCEPT = "Accept"
export const TERMS_ACCEPTING = "Accepting"
export const TERMS_LOG_OUT = "Log out"
export const TERMS_ACCEPT_FAILED = "We couldn't record your acceptance. Please try again."
export const CONFIRM_REGISTRATION = "Confirm registration"
export const BACK_TO_LOGIN = "Back to login"
export const SENDING = "Sending"
export const RESET_PASSWORD = "Reset password"
export const REQUEST_FORGOT_PASSWORD_LINK = "Request new forgot password link"
export const PASSWORDS_DO_NOT_MATCH = "Passwords do not match"
export const PLEASE_FILL_IN_REQUIRED_FIELDS = "Please fill in required fields"
export const UNAUTHORIZED_DOWNLOAD_MESSAGE = "Sorry, you don't have permission to use this feature"